import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getHorseHistorySlice = createSlice({
    name: 'horsehistory',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchhorsehistory.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchhorsehistory.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchhorsehistory.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    }
});

export const { sethorsehistory, setStatus } = getHorseHistorySlice.actions;
export default getHorseHistorySlice.reducer;

const raceTimeCache = {};

// Plain request (no redux state), year is filtered by the API
export const getHorseHistory = async ({ id, year } = {}) => {
    const cleanId = id?._id || id?.id || (typeof id === 'string' ? id : "");
    if (!cleanId) return [];
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/LatestResultOfHorses/${cleanId}?size=300${year ? `&year=${year}` : ""}`, {
        headers
    });
    const items = res.data?.data || [];

    return items.map((it) => ({
        ...it,
        RaceTime: it.RaceTime || it.RaceResultData?.RaceTime || raceTimeCache[it.RaceID] || "-"
    }));
};

export const fetchhorsehistory = createAsyncThunk('/horsehistory/fetch', getHorseHistory);
